import * as React from 'react';
import { useRef } from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  FormControl,
  CircularProgress,
  Paper,
  Grid,
  Checkbox as MUICheckbox,
  Typography,
  Divider
} from '@mui/material';
import api from "../../services/api";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { pt } from 'yup-locale-pt';
import {
  TextField,
  Select,
  Checkbox,
  CNPJField,
  Autocomplete,
  TelField,
  CEPField,
  SelectUF,
  SelectCidade,
  DialogoVisualizador,
  DialogoConfirmacao,
  Radio,
  JustificativasDropdown,
  DialogoConfirmacaoSimples,
  FileField,
} from '../../components';
import { useStoreState, useStoreActions } from 'easy-peasy';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { constituicaoEmpresaFornecedor, opcoesBooleanas, estagiosFornecedor } from '../../static';

import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import UndoOutlinedIcon from '@mui/icons-material/UndoOutlined';
import BackupOutlinedIcon from '@mui/icons-material/BackupOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const DialogoFornecedor = ({
  open, onClose, fornecedor: propFornecedor
}) => {
  const [fornecedor, setFornecedor] = React.useState(null);
  const [deveRecarregar, setDeveRecarregar] = React.useState(false);

  React.useEffect(() => {
    setFornecedor(propFornecedor);
    setDeveRecarregar(false);
  }, [propFornecedor]);

  let user = useStoreState((state) => state.auth.user);
  let loading = useStoreState((state) => state.nav.loading);
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
  const [tecnologias, setTecnologias] = React.useState([]);
  const [servicos, setServicos] = React.useState([]);
  const [regioes, setRegioes] = React.useState([]);
  const [estados, setEstados] = React.useState([]);
  const [categorias, setCategorias] = React.useState([]);
  const [fileVisualizador, setFileVisualizador] = React.useState();
  const [openDlgVis, setOpenDlgVis] = React.useState(false);
  const [openDlgJustificativa, setOpenDlgJustificativa] = React.useState(false);

  const [dlgJustTitulo, setDlgJustTitulo] = React.useState("");
  const [dlgJustNomeCampoAprovado, setDlgJustNomeCampoAprovado] = React.useState("");  //(nomeCampoAprovado);
  const [dlgJustNomeCampoJustificativa, setDlgJustNomeCampoJustificativa] = React.useState("");  //(nomeCampoJustificativa);
  const [dlgJustFornecedorId, setDlgJustFornecedorId] = React.useState("");  //(fornecedorId);
  const [statusBotao, setStatusBotao] = React.useState('');
  const [botaoAprovar, setBotaoAprovar] = React.useState(false);
  const [botaoReprovar, setBotaoReprovar] = React.useState(false);
  const [analisandoDocumentos, setAnalisandoDocumentos] = React.useState(false);
  const [analisadoLocal, setAnalisadoLocal] = React.useState(false);

  const defaultValues = {
    nome: '',
    responsavel: '',
    email: '',
    cnpj: '',
    habilitado: true,
    regioes: [],
    tecnologias: [],
    servicos: [],
    estagioFornecedor: '',
  };
  
  const schema = yup.object({
    nome: yup.string().label('Nome da empresa'),
    responsavel: yup.string().label('Nome do responsável pelas propostas comerciais'),
    email: yup.string().email().label('Email do responsável'),
    cnpj: yup.string().cnpj().label('CNPJ'),
    tecnologias: yup.array(yup.number().positive().integer()).nullable().label('Tecnologia'),
    servicos: yup.array(yup.number().positive().integer()).nullable().label('Serviços'),
    estados: yup.array(yup.number().positive().integer())
      .min(1).nullable().label('Em quais estados a empresa deseja atuar?'),
    regioes: yup.array(yup.number().positive().integer())
      .min(1).nullable().label('Região'),
    emailAux: yup.string().nullable().email().label("E-mail secundário"),
    telefone: yup.string().nullable().label("Telefone"),
    cep: yup.string().nullable().label("CEP"),
    rua: yup.string().nullable().label("Rua"),
    numero: yup.string().nullable().label("Número"),
    bairro: yup.string().nullable().label("Bairro"),
    cidade: yup.string().nullable().label("Cidade"),
    uf: yup.string().nullable().label("Estado"),

    atuaEsco: yup.boolean().nullable().label('A empresa atua como uma ESCO?'),
    constituicaoEmpresa: yup.number().nullable().label('Qual o porte da empresa?'),
    estagioFornecedor: yup.string().nullable().label('Estágio do Fornecedor'),
    idDocumento: yup.number().positive().nullable().label('Selecionar').optional(),

    observacoes: yup.string().nullable().label("Observações"),

    actAprovado: yup.number().nullable().label("Documento aprovado"),
    actJustificativa: yup.string().nullable().label('Justificativa'),

    catAprovado: yup.number().nullable().label("Documento aprovado"),
    catJustificativa: yup.string().nullable().label('Justificativa'),

    declaracaoFabricanteAprovado: yup.number().nullable().label("Documento aprovado"),
    declaracaoFabricanteJustificativa: yup.string().nullable().label('Justificativa'),

    certidaoCreaAprovado: yup.number().nullable().label("Documento aprovado"),
    certidaoCreaJustificativa: yup.string().nullable().label('Justificativa'),

    pedidoPublicoAnexo1Aprovado: yup.number().nullable().label("Documento aprovado"),
    pedidoPublicoAnexo1Justificativa: yup.string().nullable().label('Justificativa'),

    outrasInformacoesAnexo9Aprovado: yup.number().nullable().label("Documento aprovado"),
    outrasInformacoesAnexo9Justificativa: yup.string().nullable().label('Justificativa'),

    documentosMeiAprovado: yup.number().nullable().label("Documento aprovado"),
    documentosMeiJustificativa: yup.string().nullable().label('Justificativa'),

    atoSociedadeSimplesAprovado: yup.number().nullable().label("Documento aprovado"),
    atoSociedadeSimplesJustificativa: yup.string().nullable().label('Justificativa'),

    atoSociedadeAcoesAprovado: yup.number().nullable().label("Documento aprovado"),
    atoSociedadeAcoesJustificativa: yup.string().nullable().label('Justificativa'),

    negativaFalenciaAprovado: yup.number().nullable().label("Documento aprovado"),
    negativaFalenciaJustificativa: yup.string().nullable().label('Justificativa'),

    certidaoVirgenteAprovado: yup.number().nullable().label("Documento aprovado"),
    certidaoVirgenteJustificativa: yup.string().nullable().label('Justificativa'),

    balancoPatrimonialAprovado: yup.number().nullable().label("Documento aprovado"),
    balancoPatrimonialJustificativa: yup.string().nullable().label('Justificativa'),

    provaInscCnpjAprovado: yup.number().nullable().label("Documento aprovado"),
    provaInscCnpjJustificativa: yup.string().nullable().label('Justificativa'),

    cadastroContribuinteMunicipalAprovado: yup.number().nullable().label("Documento aprovado"),
    cadastroContribuinteMunicipalJustificativa: yup.string().nullable().label('Justificativa'),

    cadastroContribuinteEstadualAprovado: yup.number().nullable().label("Documento aprovado"),
    cadastroContribuinteEstadualJustificativa: yup.string().nullable().label('Justificativa'),

    regularidadeFazendaNacionalAprovado: yup.number().nullable().label("Documento aprovado"),
    regularidadeFazendaNacionalJustificativa: yup.string().nullable().label('Justificativa'),

    regularidadeFazendaEstadualAprovado: yup.number().nullable().label("Documento aprovado"),
    regularidadeFazendaEstadualJustificativa: yup.string().nullable().label('Justificativa'),

    regularidadeFazendaMunicipalAprovado: yup.number().nullable().label("Documento aprovado"),
    regularidadeFazendaMunicipalJustificativa: yup.string().nullable().label('Justificativa'),

    regularidadeFgtsAprovado: yup.number().nullable().label("Documento aprovado"),
    regularidadeFgtsJustificativa: yup.string().nullable().label('Justificativa'),

    regularidadeJusticaTrabalhoAprovado: yup.number().nullable().label("Documento aprovado"),
    regularidadeJusticaTrabalhoJustificativa: yup.string().nullable().label('Justificativa'),

    termoCompromissoAssinaturaEletronicaAprovado: yup.number().nullable().label("Documento aprovado"),
    termoCompromissoAssinaturaEletronicaJustificativa: yup.string().nullable().label('Justificativa'),

    justificativaDesabilitar: yup.string().nullable().label('Justificativa por desabilitar'),

    habilitado: yup.boolean().label('Habilitado')
  }).required();


  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema),
    defaultValues,
  });

  const { setValue, watch } = useFormRef;

  const habilitado = watch("habilitado");

  // load categorias, tecnologia e regiões
  React.useEffect(async () => {
    let mount = {
      isMounted: true
    };
    loadCategorias(mount);
    loadTecnologias(mount);
    loadServicos(mount);
    loadRegioes(mount);
    loadEstados(mount);
    return () => { mount.isMounted = false; };
  }, []);

  React.useEffect(() => {
    if (propFornecedor) {
      setStatusBotao(propFornecedor.estagioFornecedor);
    }
  }, [propFornecedor]);

  const loadEstados = async (mount) => {
    startLoading();
    try {
      let data = (await api.http.get('/estados')).data;
      if (mount.isMounted) {
        setEstados(data);
      }
      stopLoading();
    } catch (error) {
      stopLoading({ message: error.toString(), severity: 'error' });
    }
  };

  const loadCategorias = async (mount) => {
    startLoading();
    try {
      let data = (await api.http.get('/categorias')).data;
      if (mount.isMounted) {
        setCategorias(data);
      }
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };

  const loadTecnologias = async (mount) => {
    startLoading();
    try {
      let data = (await api.http.get('/tecnologias')).data;
      if (mount.isMounted) {
        setTecnologias(data);
      }
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };

  const loadServicos = async (mount) => {
    startLoading();
    try {
      let data = (await api.http.get('/servicos')).data;
      if (mount.isMounted) {
        setServicos(data);
      }
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };

  const loadRegioes = async (mount) => {
    startLoading();
    try {
      let data = (await api.http.get('/regioes')).data;
      if (mount.isMounted) {
        setRegioes(data);
      }
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };

  const resetarCamposDeArquivos = async () => {
    if (!fornecedor) return;

    const storageKey = `prevFornecedor_${fornecedor.id}`;

    const prevDataRaw = localStorage.getItem(storageKey);
    const prevData = prevDataRaw ? JSON.parse(prevDataRaw) : {};
  
    const documentos = Object
      .keys(fornecedor)
      .filter(k => k.startsWith('arquivo') && !k.endsWith('Id'))
      .map(k => {
        const baseName = k.replace('arquivo', '');
        const name = baseName.charAt(0).toLowerCase() + baseName.slice(1);
        return {
          field: name,                       
          antigoId: prevData[name]?.id,     
          novoId: fornecedor[k]?.id,       
          antigoAprovado: prevData[name]?.aprovado,
          aprovadoKey: `${name}Aprovado`,
        };
      });

      for (const { antigoId, novoId, antigoAprovado, aprovadoKey } of documentos) {
        if (novoId && antigoId !== novoId && antigoAprovado === 2) {
          try {
            const { data } = await api.http.get(
              `/fornecedores/justificativas/arquivo/${novoId}`
            );
            if (!data.existe) {
              useFormRef.current?.setValue(aprovadoKey, null, {
                shouldDirty: true,
                shouldValidate: true
              });
              useFormRef.current?.setValue(
                aprovadoKey.replace('Aprovado', 'Justificativa'),
                '',
                { shouldDirty: true, shouldValidate: true }
              );
              useFormRef.current?.clearErrors([
                aprovadoKey,
                aprovadoKey.replace('Aprovado', 'Justificativa')
              ]);
            }
          } catch (err) {
            console.error(`Erro checando justificativa para ${novoId}:`, err);
          }
        }
      }
  
    const toStore = documentos.reduce((acc, { field, novoId, aprovadoKey }) => {
      acc[field] = {
        id: novoId,
        aprovado: fornecedor[aprovadoKey]
      };
      return acc;
    }, {});
    localStorage.setItem(storageKey, JSON.stringify(toStore));
  };
  

  const { handleSubmit, reset, formState: { isDirty } } = useFormRef;

  const onSave = async (data) => {
    startLoading();
  
    if (habilitado === false && !data?.justificativaDesabilitar) {
      stopLoading({
        message: 'Preencha a Justificativa para desabilitar',
        severity: 'error'
      });
      return;
    }
  
    try {
      if (data.id) {
        await api.http.put('/fornecedores/documentos/' + data.id, data);
        const { todosrespondidos, algumpendente } = verificaStatusDocumentos(data);
        setBotaoAprovar(todosrespondidos && !algumpendente);
        setBotaoReprovar(todosrespondidos && algumpendente);
        setAnalisadoLocal(true);
      }
  
      stopLoading({ severity: 'success' });
  
    } catch (error) {
      console.error(error);
  
      let errorMessage = 'Ocorreu um erro ao salvar.';
  
      if (error.response && error.response.data) {
        const { error: serverError, camposDuplicados } = error.response.data;
  
        if (serverError) {
          errorMessage = serverError;
        }
  
        if (camposDuplicados && camposDuplicados.length > 0) {
          errorMessage += ` Campos duplicados: ${camposDuplicados.join(', ')}.`;
        }
      }
  
      stopLoading({
        message: errorMessage,
        severity: 'error'
      });
    }
  };

  const onSaveFornecedor = async (data) => {
    startLoading();

    try {
      const payload = {
        nome: data.nome,
        responsavel: data.responsavel,
        email: data.email,
        emailAux: data.emailAux,
        telefone: data.telefone,
        cep: data.cep,
        rua: data.rua,
        numero: data.numero,
        bairro: data.bairro,
        cidade: data.cidade,
        uf: data.uf,
        cnpj: data.cnpj,
        habilitado: data.habilitado,
        regioes: data.regioes,
        tecnologias: data.tecnologias,
        servicos: data.servicos,
        estado: data.estados,
        atuaEsco: data.atuaEsco,
        constituicaoEmpresa: data.constituicaoEmpresa,
        estagioFornecedor: data.estagioFornecedor,
      };

      await api.http.put(`/fornecedores/${data.id}`, payload);

      stopLoading({ severity: 'success' });
    } catch (error) {
      console.error(error);
      stopLoading({ message: error.toString(), severity: 'error' });
    }
  };

  const disabled = (() => {
    if (user.roleId == 'superAdmin') return false 
    else return true;
  });


  const close = (reload = false) => {
    reset(defaultValues);
    onClose(reload || deveRecarregar);
  };

  const verificaStatusDocumentos = (fornecedor) => {
    let todosrespondidos = false;
    let algumpendente = false;
  
    if (
      fornecedor.actAprovado &&
      fornecedor.catAprovado &&
      fornecedor.declaracaoFabricanteAprovado &&
      fornecedor.certidaoCreaAprovado &&
      fornecedor.pedidoPublicoAnexo1Aprovado &&
      fornecedor.outrasInformacoesAnexo9Aprovado &&
      (fornecedor.documentosMeiAprovado ||
        fornecedor.atoSociedadeSimplesAprovado ||
        fornecedor.atoSociedadeAcoesAprovado) &&
      fornecedor.negativaFalenciaAprovado &&
      fornecedor.certidaoVirgenteAprovado &&
      fornecedor.balancoPatrimonialAprovado &&
      fornecedor.provaInscCnpjAprovado &&
      fornecedor.cadastroContribuinteMunicipalAprovado &&
      fornecedor.cadastroContribuinteEstadualAprovado &&
      fornecedor.regularidadeFazendaNacionalAprovado &&
      fornecedor.regularidadeFazendaEstadualAprovado &&
      fornecedor.regularidadeFazendaMunicipalAprovado &&
      fornecedor.regularidadeFgtsAprovado &&
      fornecedor.regularidadeJusticaTrabalhoAprovado &&
      fornecedor.termoCompromissoAssinaturaEletronicaAprovado
    ) {
      todosrespondidos = true;
    }
  
    if (
      fornecedor.actAprovado === 2 ||
      fornecedor.catAprovado === 2 ||
      fornecedor.declaracaoFabricanteAprovado === 2 ||
      fornecedor.certidaoCreaAprovado === 2 ||
      fornecedor.pedidoPublicoAnexo1Aprovado === 2 ||
      fornecedor.outrasInformacoesAnexo9Aprovado === 2 ||
      (fornecedor.constituicaoEmpresa === 1
        ? fornecedor.documentosMeiAprovado === 2 || !fornecedor.documentosMeiAprovado
        : false) ||
      (fornecedor.constituicaoEmpresa === 2
        ? fornecedor.atoSociedadeSimplesAprovado === 2 || !fornecedor.atoSociedadeSimplesAprovado
        : false) ||
      (fornecedor.constituicaoEmpresa === 3
        ? fornecedor.atoSociedadeAcoesAprovado === 2 || !fornecedor.atoSociedadeAcoesAprovado
        : false) ||
      fornecedor.negativaFalenciaAprovado === 2 ||
      fornecedor.certidaoVirgenteAprovado === 2 ||
      fornecedor.balancoPatrimonialAprovado === 2 ||
      fornecedor.provaInscCnpjAprovado === 2 ||
      fornecedor.cadastroContribuinteMunicipalAprovado === 2 ||
      fornecedor.cadastroContribuinteEstadualAprovado === 2 ||
      fornecedor.regularidadeFazendaNacionalAprovado === 2 ||
      fornecedor.regularidadeFazendaEstadualAprovado === 2 ||
      fornecedor.regularidadeFazendaMunicipalAprovado === 2 ||
      fornecedor.regularidadeFgtsAprovado === 2 ||
      fornecedor.regularidadeJusticaTrabalhoAprovado === 2 ||
      fornecedor.termoCompromissoAssinaturaEletronicaAprovado === 2
    ) {
      algumpendente = true;
    }
  
    return { todosrespondidos, algumpendente };
  };  

  React.useEffect(() => {
    if (!open || !fornecedor) return;

    setAnalisadoLocal(false);
    reset({
      ...fornecedor,
      regioes: fornecedor.regiao?.map((r) => r.id) || [],
      tecnologias: fornecedor.tecnologia?.map((t) => t.id) || [],
      servicos: fornecedor.servico?.map((t) => t.id) || [],
      estados: fornecedor.estado?.map((e) => e.id) || [],
    });

    const atualizarBotoes = () => {
      const { todosrespondidos, algumpendente } = verificaStatusDocumentos(fornecedor);
      setBotaoAprovar(todosrespondidos && !algumpendente);
      setBotaoReprovar(todosrespondidos && algumpendente);
    };

    atualizarBotoes();
    const t = window.setTimeout(atualizarBotoes, 0);

    if (
      (fornecedor.estagioFornecedor === 'analise' && fornecedor.analisadorId)
      || fornecedor.estagioFornecedor === 'pendencia'
      || fornecedor.estagioFornecedor === 'ativo'
      || user.roleId === 'superAdmin'
    ) {
      setAnalisandoDocumentos(true);
    } else {
      setAnalisandoDocumentos(false);
    }
    resetarCamposDeArquivos();

    return () => window.clearTimeout(t);
  }, [open, fornecedor]);

  React.useEffect(() => {
    const fields = watch();
    Object.keys(fields || {}).forEach((key) => {
      if (key.endsWith('Aprovado') && fields[key] !== 2) {
        const justificativaKey = key.replace('Aprovado', 'Justificativa');
        setValue(justificativaKey, '', { shouldDirty: true, shouldValidate: true });
      }
    });
  }, [watch, setValue]);

  const onConfirmaDlgJustificativa = async (data) => {
    //confirmar a justificativa
    // console.log("confirmar justificativa")

    startLoading();
    try {

      // console.log("data: ", data);

      let datar = (await api.http.put('/fornecedores/document/reprove/' + dlgJustFornecedorId, {

        id: dlgJustFornecedorId,
        nomeCampo: dlgJustNomeCampoAprovado,
        nomeCampoJustificativa: dlgJustNomeCampoJustificativa,
        justificativa: data.observacoes,
      })).data;

      // setFornecedor(data[0]);

      stopLoading({ severity: 'success' });
      // setOpenConfirmaExcluir(false);

    } catch (error) {
      stopLoading({ message: error.toString(), severity: 'error' });
      // setOpenConfirmaExcluir(false);
      throw error;
    }

    setOpenDlgJustificativa(false);
  };

  const onNaoConfirmaDlgJustificativa = () => {
    setOpenDlgJustificativa(false);
  };

  const [openDlgAdd, setOpenDlgAdd] = React.useState(false);
  const [nomeCampoDocumento, setNomeCampoDocumento] = React.useState(null);
  const [nomeDocumento, setNomeDocumento] = React.useState(null);

  const [openConfirmaExcluir, setOpenConfirmaExcluir] = React.useState(false);
  const [excluirNomeCampo, setExcluirNomeCampo] = React.useState(null);
  const [excluirTitulo, setExcluirTitulo] = React.useState(null);

  const watchIdDocumento = watch("idDocumento");

  const onCloseAdd = () => {
    setNomeCampoDocumento(null);
    setNomeDocumento(null);
    setValue("idDocumento", null);
    setOpenDlgAdd(false);
  };

  const onOpenDlgAdd = (campo, tituloDoc) => {
    setValue("idDocumento", null);
    setNomeCampoDocumento(campo);
    setNomeDocumento(tituloDoc);
    setOpenDlgAdd(true);
  };

  const onConfirmarAdd = async () => {
    startLoading();
    try {
      const response = await api.http.put(
        `/fornecedores/add/file/${fornecedor.id}`,
        {
          id: fornecedor.id,
          nomeCampo: nomeCampoDocumento,
          idDocumento: watchIdDocumento,
        }
      );

      const fileData = response.data?.[0];

      if (fornecedor) {
        setFornecedor(prev => ({
          ...prev,
          ...fileData
        }));
      }

      setDeveRecarregar(true);
      stopLoading({ severity: 'success' });
      setOpenDlgAdd(false);
    } catch (error) {
      stopLoading({ message: error.toString(), severity: 'error' });
      setOpenDlgAdd(false);
    }
  };

  const onDelete = (campo, tituloDoc) => {
    setExcluirNomeCampo(campo);
    setExcluirTitulo(tituloDoc);
    setOpenConfirmaExcluir(true);
  };

  const onConfirmaExcluir = async () => {
    startLoading();
    try {
      const response = await api.http.put(`/fornecedores/delete/file/${fornecedor.id}`, {
        id: fornecedor.id,
        nomeCampo: excluirNomeCampo,
        idDocumento: 0,
      });

      const fileData = response.data?.[0];

      if (fornecedor) {
        setFornecedor(prev => ({
          ...prev,
          ...fileData
        }));
      }

      setDeveRecarregar(true);
      stopLoading({ severity: 'success' });
      setOpenConfirmaExcluir(false);
    } catch (error) {
      stopLoading({ message: error.toString(), severity: 'error' });
      setOpenConfirmaExcluir(false);
    }
  };

  const onNaoConfirmaExcluir = () => {
    setOpenConfirmaExcluir(false);
  };

  const onOpenDlgVis = (param1, param2, param3) => {
    setFileVisualizador(param1);
    setOpenDlgVis(true);
  };

  const onCloseDlgVis = () => {
    setOpenDlgVis(false);
  };

  const tratarErroAcaoFornecedor = (error) => {
    console.error(error);
    stopLoading({
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        error.toString(),
      severity: 'error'
    });
  };

  const onAprova = async () => {
    startLoading();
    try {

      await api.http.put('/fornecedores/orcamentos/alterarestagio/' + fornecedor.id, {
        estagioFornecedor: "ativo"
      });

      stopLoading({ severity: 'success' });
      close(true);

    } catch (error) {
      tratarErroAcaoFornecedor(error);
    }
  }

  const onPendencia = async () => {
    startLoading();
    try {

      await api.http.put('/fornecedores/orcamentos/alterarestagio/' + fornecedor.id, {
        estagioFornecedor: "pendencia"
      });

      stopLoading({ severity: 'success' });
      close(true);
    } catch (error) {
      tratarErroAcaoFornecedor(error);
    }
  }

  const onReprove = async () => {
    startLoading();
    try {

      await api.http.put('/fornecedores/orcamentos/alterarestagio/' + fornecedor.id, {
        estagioFornecedor: "inativo"
      });

      stopLoading({ severity: 'success' });
      close(true);
    } catch (error) {
      tratarErroAcaoFornecedor(error);
    }
  }

  const handleIniciarAnalise = async () => {
    startLoading();
    try {

      await api.http.put(`/fornecedores/orcamentos/usuario/iniciar/analise/${fornecedor?.id}/${user.id}`, {
        usuarioId: user.id
      });

      stopLoading({ severity: 'success' });
      close(true);
    } catch (error) {
      tratarErroAcaoFornecedor(error);
    }
  };

  // Função para renderizar o botão de iniciar análise
  const renderIniciarAnaliseButton = () => {
    if (fornecedor?.estagioFornecedor === "analise" && !fornecedor?.analisadorId) {
      return (
        <Button color="success" onClick={handleIniciarAnalise}>
          INICIAR ANÁLISE
        </Button>
      );
    }
    return null;
  };

  // Função para renderizar o botão de salvar
  const renderSalvarButton = () => {
    const isAdmin = user.roleId === 'superAdmin';
    if (isAdmin || (fornecedor?.estagioFornecedor === "analise"
      && fornecedor?.analisadorId === user.id)) {
      return (
        <Button
          color="primary"
          onClick={handleSubmit(onSave)}
          disabled={!isDirty}
        >
          SALVAR
        </Button>
      );
    }
    return null;
  };

  const renderSalvarAdminButton = () => {
    if (user.roleId === 'superAdmin') {
      return (
        <Button
          color="primary"
          variant="outlined"
          onClick={handleSubmit(onSaveFornecedor)}
          disabled={!isDirty}
        >
          SALVAR DADOS
        </Button>
      );
    }
    return null;
  };

  // Função para renderizar o botão de aprovar
  const renderAprovarButton = () => {
    const isAdmin = user.roleId === 'superAdmin';
    if (isAdmin || (botaoAprovar && (fornecedor?.analisado || analisadoLocal))) {
      return (
        <Button
          color="success"
          variant="outlined"
          onClick={handleSubmit(onAprova)}
        >
          APROVAR
        </Button>
      );
    }
    return null;
  };

  // Função para renderizar os botões de pendência e reprovar
  const renderReprovarButtons = () => {
    const isAdmin = user.roleId === 'superAdmin';
    if (isAdmin || (botaoReprovar && (fornecedor?.analisado || analisadoLocal))) {
      return (
        <>
          <Button
            color="warning"
            variant="outlined"
            onClick={handleSubmit(onPendencia)}
          >
            PENDÊNCIA
          </Button>
          <Button
            color="error"
            variant="outlined"
            onClick={handleSubmit(onReprove)}
          >
            REPROVAR
          </Button>
        </>
      );
    }
    return null;
  };

  const getDescricaoEstagio = (cod) => {
    const estagio = estagiosFornecedor.find((e) => e.cod === cod);
    return estagio ? estagio.descricao : "Desconhecido";
  };

  const renderDocumentoFormBox = (
    titulo,
    arquivoKey,
    idKey,
    aprovadoKey,
    justificativaKey,
    colunaReferencia,
    fieldPrefix
  ) => {
    const arquivo = fornecedor?.[arquivoKey];
    const id = fornecedor?.[idKey];
    const estagio = fornecedor?.estagioFornecedor;
    const aprovado = watch(`${fieldPrefix}Aprovado`);
    const isAdmin = user.roleId === 'superAdmin';
  
    return (
      <Box
        sx={{
          backgroundColor: 'white',
          borderBottom: '1px solid #FAFBFB',
          marginTop: 2,
          padding: 2,
        }}
      >
        <Typography variant="body1">{titulo}</Typography>
  
        <Grid container spacing={2} alignItems="flex-start">
          <Grid item xs={isAdmin ? 3 : 2} sx={{ mt: 1 }}>
            {isAdmin ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {id ? (
                  <>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => onOpenDlgVis(arquivo)}
                      startIcon={<ArticleOutlinedIcon />}
                      fullWidth
                    >
                      Visualizar
                    </Button>
                    <Button
                      variant="outlined"
                      color="warning"
                      onClick={() => onDelete(idKey, titulo)}
                      startIcon={<DeleteForeverOutlinedIcon />}
                      fullWidth
                    >
                      Remover
                    </Button>
                  </>
                ) : (
                  <Button
                    variant="outlined"
                    color="success"
                    onClick={() => onOpenDlgAdd(idKey, titulo)}
                    startIcon={<BackupOutlinedIcon />}
                    fullWidth
                  >
                    Incluir
                  </Button>
                )}
              </Box>
            ) : (
              estagio !== 'inativo' && id ? (
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => onOpenDlgVis(arquivo)}
                  startIcon={<ArticleOutlinedIcon />}
                  fullWidth
                >
                  Visualizar
                </Button>
              ) : (
                <Typography variant="body2" sx={{ width: '100%', textAlign: 'center' }}>
                  Ainda não há arquivos carregados.
                </Typography>
              )
            )}
          </Grid>
  
          {(estagio === 'analise' || estagio === 'pendencia' || isAdmin) && id && (
            <>
              <Grid item xs={3} sx={{ mt: 1 }}>
                <FormControl fullWidth>
                  <Select
                    field={`${fieldPrefix}Aprovado`}
                    useFormRef={useFormRef}
                    schema={schema}
                    disabled={!isAdmin && (estagio === 'pendencia' || fornecedor.analisadorId !== user.id)}
                    options={opcoesBooleanas}
                  />
                </FormControl>
              </Grid>
  
              {aprovado === 2 && (
                <Grid item xs={isAdmin ? 6 : 7}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', mt: 0 }}>
                    {(estagio === 'analise' || isAdmin) && (
                      <FormControl fullWidth sx={{ mt: 0 }} >
                        <TextField
                          margin="dense"
                          fullWidth
                          field={`${fieldPrefix}Justificativa`}
                          useFormRef={useFormRef}
                          schema={schema}
                        />
                      </FormControl>
                    )}
  
                    <Box sx={{ mt: 1 }}>
                      <JustificativasDropdown
                        fornecedor={fornecedor}
                        colunaReferencia={colunaReferencia}
                      />
                    </Box>
                  </Box>
                </Grid>
              )}
            </>
          )}
        </Grid>
      </Box>
    );
  };  

  return (
    <>
      <DialogoVisualizador file={fileVisualizador}
        open={openDlgVis}
        onClose={() => onCloseDlgVis()} />

      <DialogoConfirmacaoSimples
        title="Atenção"
        open={openConfirmaExcluir}
        onSim={onConfirmaExcluir}
        onNao={onNaoConfirmaExcluir}
      >
        <h4>{excluirTitulo}</h4>
        Tem certeza que deseja excluir o arquivo?
      </DialogoConfirmacaoSimples>

      <Dialog open={openDlgAdd} onClose={onCloseAdd} fullWidth maxWidth="xs">
        <DialogTitle>Adicionar arquivo</DialogTitle>
        <DialogContent>
          <Typography variant="h6" sx={{ mb: 1 }}>{nomeDocumento}</Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            Selecione o documento que deseja incluir:
          </Typography>
          <FormControl fullWidth>
            <FileField
              field="idDocumento"
              fileData={null}
              useFormRef={useFormRef}
              schema={schema}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button color="warning" onClick={onCloseAdd}>
            Fechar
          </Button>
          <Button
            color="success"
            variant="contained"
            disabled={!watchIdDocumento}
            onClick={onConfirmarAdd}
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      <DialogoConfirmacao
        title="Atenção"
        open={openDlgJustificativa}
        onSim={onConfirmaDlgJustificativa}
        onNao={onNaoConfirmaDlgJustificativa}
      >
        <h5>{dlgJustTitulo}</h5>
        Descreva aqui a justificativa para a não aprovar o documento.
      </DialogoConfirmacao>

      <Dialog open={open} onClose={() => close()} fullWidth
        maxWidth="lg" sx={{ '& .MuiDialog-paper': { width: '80%' } }}>
        <DialogTitle>
          <Typography variant="body1"><b>Dados do fornecedor : </b>
            {fornecedor?.nome} - <i>{getDescricaoEstagio(fornecedor?.estagioFornecedor)}</i>
          </Typography>
        </DialogTitle >
        <DialogContent dividers>
          {user.roleId === 'superAdmin' && (
            <FormControl sx={{ my: 2 }} fullWidth>
              <Select
                field="estagioFornecedor"
                useFormRef={useFormRef}
                schema={schema}
                options={estagiosFornecedor.map((e) => ({ id: e.cod, label: e.descricao }))}
              />
            </FormControl>
          )}
          <FormControl sx={{ my: 2 }} fullWidth>
            <CNPJField
              margin="dense"
              fullWidth
              field="cnpj"
              useFormRef={useFormRef}
              schema={schema}
              disabled={disabled()}
              InputLabelProps={{ shrink: true }} />
          </FormControl>
          <FormControl sx={{ my: 2 }} fullWidth>
            <TextField
              margin="dense"
              fullWidth
              field="nome"
              disabled={disabled()}
              useFormRef={useFormRef} schema={schema} />
          </FormControl>
          <FormControl sx={{ my: 2 }} fullWidth>
            <TextField
              margin="dense"
              fullWidth
              disabled={disabled()}
              field="responsavel"
              useFormRef={useFormRef} schema={schema} />
          </FormControl>
          <FormControl sx={{ my: 2 }} fullWidth>
            <TextField
              margin="dense"
              fullWidth
              field="email"
              type="email"
              disabled={disabled()}
              useFormRef={useFormRef} schema={schema} />
          </FormControl>
          <FormControl sx={{ my: 1 }} fullWidth>
            <TextField
              margin="dense"
              fullWidth
              field="emailAux"
              type="email"
              useFormRef={useFormRef}
              disabled={disabled()}
              schema={schema} />
          </FormControl>

          <FormControl sx={{ my: 1 }} fullWidth>
            <TelField
              field="telefone"
              disabled={disabled()}
              useFormRef={useFormRef}
              schema={schema}
              InputLabelProps={{ shrink: true }} />
          </FormControl>

          <FormControl sx={{ my: 2 }} fullWidth>
            <CEPField
              field="cep"
              disabled={disabled()}
              useFormRef={useFormRef}
              schema={schema} />
          </FormControl>


          <FormControl sx={{ my: 2 }} fullWidth>
            <TextField
              field="rua"
              disabled={disabled()}
              useFormRef={useFormRef}
              schema={schema} />
          </FormControl>

          <FormControl sx={{ my: 2 }} fullWidth>
            <TextField
              field="numero"
              disabled={disabled()}
              useFormRef={useFormRef}
              schema={schema} />
          </FormControl>

          <FormControl sx={{ my: 2 }} fullWidth>
            <TextField
              field="bairro"
              disabled={disabled()}
              useFormRef={useFormRef}
              schema={schema} />
          </FormControl>

          <FormControl sx={{ my: 2 }} fullWidth>
            <TextField
              field="uf"
              disabled={disabled()}
              useFormRef={useFormRef}
              schema={schema} />
          </FormControl>


          <FormControl sx={{ my: 2 }} fullWidth>
            <TextField
              field="cidade"
              disabled={disabled()}
              useFormRef={useFormRef}
              schema={schema} />
          </FormControl>

          <FormControl sx={{ my: 2 }} fullWidth>
            <Autocomplete
              multiple
              disableCloseOnSelect
              field="tecnologias"
              useFormRef={useFormRef}
              schema={schema}
              options={tecnologias}
              readOnly={user.roleId !== 'superAdmin'}
              sx={{
                '& .MuiAutocomplete-input': {
                  cursor: user.roleId !== 'superAdmin' ? 'not-allowed' : 'text',
                  opacity: user.roleId !== 'superAdmin' ? 0.7 : 1,
                },
                '& .MuiChip-root': {
                  backgroundColor: user.roleId !== 'superAdmin'
                    ? 'rgba(0, 0, 0, 0.12)'
                    : undefined,
                  cursor: user.roleId !== 'superAdmin' ? 'not-allowed' : 'pointer',
                },
              }}
              renderOption={(props, option, { selected }) => (
                <li
                  {...props}
                  style={{
                    pointerEvents: user.roleId !== 'superAdmin' ? 'none' : 'auto',
                  }}
                >
                  <MUICheckbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.label}
                </li>
              )}
            />
          </FormControl>

          <FormControl sx={{ my: 2 }} fullWidth>
            <Autocomplete
              multiple
              disableCloseOnSelect={user.roleId !== 'superAdmin'}
              field="servicos"
              useFormRef={useFormRef}
              schema={schema}
              options={servicos}
              readOnly={user.roleId !== 'superAdmin'}
              sx={{
                '& .MuiAutocomplete-input': {
                  cursor: user.roleId !== 'superAdmin' ? 'not-allowed' : 'text',
                  opacity: user.roleId !== 'superAdmin' ? 0.7 : 1,
                },
                '& .MuiChip-root': {
                  backgroundColor: user.roleId !== 'superAdmin'
                    ? 'rgba(0, 0, 0, 0.12)'
                    : undefined,
                  cursor: user.roleId !== 'superAdmin' ? 'not-allowed' : 'pointer',
                },
              }}
              renderOption={(props, option, { selected }) => (
                <li
                  {...props}
                  style={{
                    pointerEvents: user.roleId !== 'superAdmin' ? 'none' : 'auto',
                  }}
                >
                  <MUICheckbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.label}
                </li>
              )}
            />
          </FormControl>

          <FormControl sx={{ my: 2 }} fullWidth>
            <Autocomplete
              multiple
              disableCloseOnSelect
              field="estados"
              useFormRef={useFormRef}
              schema={schema}
              options={estados}
              readOnly={user.roleId !== 'superAdmin'}
              sx={{
                '& .MuiAutocomplete-input': {
                  cursor: user.roleId !== 'superAdmin' ? 'not-allowed' : 'text',
                  opacity: user.roleId !== 'superAdmin' ? 0.7 : 1,
                },
                '& .MuiChip-root': {
                  backgroundColor: user.roleId !== 'superAdmin'
                    ? 'rgba(0, 0, 0, 0.12)'
                    : undefined,
                  cursor: user.roleId !== 'superAdmin' ? 'not-allowed' : 'pointer',
                },
              }}
              renderOption={(props, option, { selected }) => (
                <li
                  {...props}
                  style={{
                    pointerEvents: user.roleId !== 'superAdmin' ? 'none' : 'auto',
                  }}
                >
                  <MUICheckbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.label}
                </li>
              )}
            />
          </FormControl>

          <FormControl sx={{ my: 2 }} fullWidth>
            <Autocomplete
              multiple
              disableCloseOnSelect={user.roleId !== 'superAdmin'}
              field="regioes"
              useFormRef={useFormRef}
              schema={schema}
              options={regioes}
              readOnly={user.roleId !== 'superAdmin'}
              sx={{
                '& .MuiAutocomplete-input': {
                  cursor: user.roleId !== 'superAdmin' ? 'not-allowed' : 'text',
                  opacity: user.roleId !== 'superAdmin' ? 0.7 : 1,
                },
                '& .MuiChip-root': {
                  backgroundColor: user.roleId !== 'superAdmin'
                    ? 'rgba(0, 0, 0, 0.12)'
                    : undefined,
                  cursor: user.roleId !== 'superAdmin' ? 'not-allowed' : 'pointer',
                },
              }}
              renderOption={(props, option, { selected }) => (
                <li
                  {...props}
                  style={{
                    pointerEvents: user.roleId !== 'superAdmin' ? 'none' : 'auto',
                  }}
                >
                  <MUICheckbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.label}
                </li>
              )}
            />
          </FormControl>

          {user.roleId === 'superAdmin' &&
            <FormControl sx={{ my: 2 }} fullWidth>
              <Checkbox field="habilitado"
                useFormRef={useFormRef} schema={schema} />
            </FormControl>
          }
          <FormControl sx={{ my: 2 }} fullWidth>
            <Checkbox field="atuaEsco" disabled={disabled()}
              useFormRef={useFormRef} schema={schema} />
          </FormControl>

          <FormControl x={{ mb: 2 }} fullWidth>
            <Select
              field="constituicaoEmpresa" disabled={disabled()}
              useFormRef={useFormRef} schema={schema}
              options={constituicaoEmpresaFornecedor} />
          </FormControl>
          {analisandoDocumentos && (
            <>
              <div className={`conteudo ${analisandoDocumentos ? 'visivel' : 'oculto'}`}>
                <Divider>
                  <h3>Documentação Técnica</h3>
                  <h3>Qualificação Técnica</h3>
                </Divider>
                {renderDocumentoFormBox(
                  '1. ACT',
                  'arquivoAct',
                  'actId',
                  'actAprovado',
                  'actJustificativa',
                  'act_aprovado',
                  'act'
                )}

                {renderDocumentoFormBox(
                  '2. CAT',
                  'arquivoCat',
                  'catId',
                  'catAprovado',
                  'catJustificativa',
                  'cat_aprovado',
                  'cat'
                )}

                {renderDocumentoFormBox(
                  '3. Declaração do Fabricante',
                  'arquivodeclaracaoFabricanteId',
                  'declaracaoFabricanteId',
                  'declaracaoFabricanteAprovado',
                  'declaracaoFabricanteJustificativa',
                  'declaracao_fabricante_aprovado',
                  'declaracaoFabricante'
                )}

                {renderDocumentoFormBox(
                  '4. Certidão de Registro - CREA Pessoa Jurídica',
                  'arquivocertidaoCreaId',
                  'certidaoCreaId',
                  'certidaoCreaAprovado',
                  'certidaoCreaJustificativa',
                  'certidao_crea_aprovado',
                  'certidaoCrea'
                )}

                <Divider>
                  <h3>Documentação habilitação</h3>
                  <h3>Qualificação Técnica</h3>
                </Divider>

                {renderDocumentoFormBox(
                  '5. Pedido Público (Anexo I)',
                  'arquivopedidoPublicoAnexo1Id',
                  'pedidoPublicoAnexo1Id',
                  'pedidoPublicoAnexo1Aprovado',
                  'pedidoPublicoAnexo1Justificativa',
                  'pedido_publico_anexo1_aprovado',
                  'pedidoPublicoAnexo1'
                )}
                
                {renderDocumentoFormBox(
                  '6. Declaração de Outras Informações (Anexo IX)',
                  'arquivooutrasInformacoesAnexo9Id',
                  'outrasInformacoesAnexo9Id',
                  'outrasInformacoesAnexo9Aprovado',
                  'outrasInformacoesAnexo9Justificativa',
                  'outras_informacoes_anexo9_aprovado',
                  'outrasInformacoesAnexo9'
                )}

                {fornecedor?.constituicaoEmpresa === 1 &&
                  renderDocumentoFormBox(
                    '7. Documentos - MEI',
                    'arquivodocumentosMeiId',
                    'documentosMeiId',
                    'documentosMeiAprovado',
                    'documentosMeiJustificativa',
                    'documentos_mei_aprovado',
                    'documentosMei'
                  )}

                {fornecedor?.constituicaoEmpresa === 2 &&
                  renderDocumentoFormBox(
                    '7. Ato Constitutivo - Sociedades Simples',
                    'arquivoatoSociedadeSimplesId',
                    'atoSociedadeSimplesId',
                    'atoSociedadeSimplesAprovado',
                    'atoSociedadeSimplesJustificativa',
                    'ato_sociedade_simples_aprovado',
                    'atoSociedadeSimples'
                  )}

                {fornecedor?.constituicaoEmpresa === 3 &&
                  renderDocumentoFormBox(
                    '7. Ato Constitutivo - Sociedades por Ações',
                    'arquivoatoSociedadeAcoesId',
                    'atoSociedadeAcoesId',
                    'atoSociedadeAcoesAprovado',
                    'atoSociedadeAcoesJustificativa',
                    'ato_sociedade_acoes_aprovado',
                    'atoSociedadeAcoes'
                  )}

                <Divider>
                  <h3>Qualificação Econômico-Financeira</h3>
                </Divider>

                {renderDocumentoFormBox(
                  '8. Certidão Negativa Falência ou Certidão Judicial - não superior a 90 dias',
                  'arquivonegativaFalenciaId',
                  'negativaFalenciaId',
                  'negativaFalenciaAprovado',
                  'negativaFalenciaJustificativa',
                  'negativa_falencia_aprovado',
                  'negativaFalencia'
                )}

                {renderDocumentoFormBox(
                  '9. Certidão vigente emitida pela instância Judicial',
                  'arquivocertidaoVirgenteId',
                  'certidaoVirgenteId',
                  'certidaoVirgenteAprovado',
                  'certidaoVirgenteJustificativa',
                  'certidao_virgente_aprovado',
                  'certidaoVirgente'
                )}

                {renderDocumentoFormBox(
                  '10. Balanço Patrimonial e Demonst. contábeis',
                  'arquivobalancoPatrimonialId',
                  'balancoPatrimonialId',
                  'balancoPatrimonialAprovado',
                  'balancoPatrimonialJustificativa',
                  'balanco_patrimonial_aprovado',
                  'balancoPatrimonial'
                )}

                {renderDocumentoFormBox(
                  '11. Prova de Inscrição no CNPJ',
                  'arquivoprovaInscCnpjId',
                  'provaInscCnpjId',
                  'provaInscCnpjAprovado',
                  'provaInscCnpjJustificativa',
                  'prova_insc_cnpj_aprovado',
                  'provaInscCnpj'
                )}

                {renderDocumentoFormBox(
                  '12. Cadastro de Contribuinte Municipal',
                  'arquivocadastroContribuinteMunicipalId',
                  'cadastroContribuinteMunicipalId',
                  'cadastroContribuinteMunicipalAprovado',
                  'cadastroContribuinteMunicipalJustificativa',
                  'cadastro_contribuinte_municipal_aprovado',
                  'cadastroContribuinteMunicipal'
                )}
                
                {renderDocumentoFormBox(
                  '13. Cadastro de Contribuinte Estadual',
                  'arquivocadastroContribuinteEstadualId',
                  'cadastroContribuinteEstadualId',
                  'cadastroContribuinteEstadualAprovado',
                  'cadastroContribuinteEstadualJustificativa',
                  'cadastro_contribuinte_estadual_aprovado',
                  'cadastroContribuinteEstadual'
                )}

                <Divider>
                  <h3>Regularidade Fiscal</h3>
                </Divider>

                {renderDocumentoFormBox(
                  '14. Prova de Regularidade - Fazenda Municipal',
                  'arquivoregularidadeFazendaMunicipalId',
                  'regularidadeFazendaMunicipalId',
                  'regularidadeFazendaMunicipalAprovado',
                  'regularidadeFazendaMunicipalJustificativa',
                  'regularidade_fazenda_municipal_aprovado',
                  'regularidadeFazendaMunicipal'
                )}

                {renderDocumentoFormBox(
                  '15. Prova de Regularidade - Fazenda Estadual',
                  'arquivoregularidadeFazendaEstadualId',
                  'regularidadeFazendaEstadualId',
                  'regularidadeFazendaEstadualAprovado',
                  'regularidadeFazendaEstadualJustificativa',
                  'regularidade_fazenda_estadual_aprovado',
                  'regularidadeFazendaEstadual'
                )}

                {renderDocumentoFormBox(
                  '16. Prova de Regularidade - Fazenda Nacional',
                  'arquivoregularidadeFazendaNacionalId',
                  'regularidadeFazendaNacionalId',
                  'regularidadeFazendaNacionalAprovado',
                  'regularidadeFazendaNacionalJustificativa',
                  'regularidade_fazenda_nacional_aprovado',
                  'regularidadeFazendaNacional'
                )}

                {renderDocumentoFormBox(
                  '17. Prova de Regularidade - FGTS',
                  'arquivoregularidadeFgtsId',
                  'regularidadeFgtsId',
                  'regularidadeFgtsAprovado',
                  'regularidadeFgtsJustificativa',
                  'regularidade_fgts_aprovado',
                  'regularidadeFgts'
                )}

                {renderDocumentoFormBox(
                  '18. Prova de Regularidade – Justiça do Trabalho',
                  'arquivoregularidadeJusticaTrabalhoId',
                  'regularidadeJusticaTrabalhoId',
                  'regularidadeJusticaTrabalhoAprovado',
                  'regularidadeJusticaTrabalhoJustificativa',
                  'regularidade_justica_trabalho_aprovado',
                  'regularidadeJusticaTrabalho'
                )}

                {renderDocumentoFormBox(
                  '19. Termo de Compromisso – Assinatura do responsável legal',
                  'arquivotermoCompromissoAssinaturaEletronicaId',
                  'termoCompromissoAssinaturaEletronicaId',
                  'termoCompromissoAssinaturaEletronicaAprovado',
                  'termoCompromissoAssinaturaEletronicaJustificativa',
                  'termo_compromisso_assinatura_eletronica_aprovado',
                  'termoCompromissoAssinaturaEletronica'
                )}
              
              </div>
            </>
          )}
        </DialogContent>
        <DialogActions>
          {loading > 0 && <CircularProgress
            size={30}
            sx={{
              'position': 'absolute',
              'left': 25,
              'bottom': 12
            }} />}
          <Button color="inherit" onClick={() => close()}>
            CANCELAR
          </Button>

          {renderIniciarAnaliseButton()}
          {renderSalvarAdminButton()}
          {renderSalvarButton()}
          {renderAprovarButton()}
          {renderReprovarButtons()}

        </DialogActions>
      </Dialog>
    </>
  );
};


export default DialogoFornecedor;
